import { AUTHORITY_OPTIONS, PAGES } from "./constants";
import { Action, ActionType, State } from "./types";

export const authorityOptions = [
  {
    label: "Authority to disclose information only",
    value: AUTHORITY_OPTIONS.INFO_ONLY,
    description:
      "Permits authorised person to obtain account information and arrange for payments only.",
  },
  {
    label: "Authority to disclose information and maintain my account",
    value: AUTHORITY_OPTIONS.FULL,
    description:
      "Permits authorised person to: obtain account information, act on my behalf including to negotiate with Latitude and make legally binding decisions regarding the account, and undertake the additional activities listed in item 3.",
  },
  {
    label: "Neither",
    value: AUTHORITY_OPTIONS.NEITHER,
  },
];

export const emptyFormValues = {
  primaryFullName: "",
  primaryDateOfBirth: {
    day: "",
    month: "",
    year: "",
  },
  primaryAccountNumber: "",
  additionalFullName: "",
  email: "",
  additionalDateOfBirth: {
    day: "",
    month: "",
    year: "",
  },
  agreeToAdditionalCardHolder: false,
  agreeToPrivacyPolicy: false,
  authorityOption: AUTHORITY_OPTIONS.INFO_ONLY,
};

export const initialState: State = {
  page: PAGES.FORM,
  formValues: emptyFormValues,
  errorType: undefined,
};

export const reducer = (state: State, action: Action): State => {
  switch (state.page) {
    case PAGES.FORM: {
      switch (action.type) {
        case ActionType.ACCOUNT_INFO_LOADED: {
          return { ...state, accountInfo: action.accountInfo };
        }
        case ActionType.FORM_SUBMITTED: {
          return {
            ...state,
            formValues: action.formValues,
            page: PAGES.SUCCESS,
          };
        }

        default: {
          return state;
        }
      }
    }

    default: {
      return state;
    }
  }
};
